<script setup>
</script>

<template>
  <main class="aide container" aria-labelledby="titre-aide">
    <h1 id="titre-aide">Mon achat en ligne, mode d'emploi</h1>
    <hr/>

    <ol class="schema_aide row">

      <li class="etape col-sm-4 col-12">
        <article>
          <h2 class="titre_aide">Étape 1</h2>

          <img
            class="img-fluid"
            src="@/assets/etape1.png"
            alt=""
            aria-hidden="true"
          />

          <p class="texte_aide">
            J'achète mon billet en ligne en me laissant guider.
          </p>
        </article>
      </li>

      <li class="etape col-sm-4 col-12">
        <article>
          <h2 class="titre_aide">Étape 2</h2>

          <img
            class="img-fluid"
            src="@/assets/etape2.png"
            alt=""
            aria-hidden="true"
          />

          <p class="texte_aide">
            Je reçois mon billet par email sous forme de QR Code : je peux l'imprimer ou le conserver dans mon téléphone.
          </p>
        </article>
      </li>

      <li class="etape col-sm-4 col-12">
        <article>
          <h2 class="titre_aide">Étape 3</h2>

          <img
            class="img-fluid"
            src="@/assets/etape3.png"
            alt=""
            aria-hidden="true"
          />

          <p class="texte_aide">
            Je présente mon QR Code imprimé ou directement sur mon portable au conducteur de bus.
          </p>
        </article>
      </li>

    </ol>
  </main>
</template>

<style scoped lang="scss">
@import "@/assets/main";

.aide {
  text-align: center;

  h1 {
    color: $firstcolor;
  }

  .schema_aide {
    margin: 0;
    padding: 1rem;
    list-style: none;
    border: 3px solid $secondcolor;
    border-radius: 20px;

    .etape {
      padding-left: 2rem;
      padding-right: 2rem;

      .titre_aide {
        color: $firstcolor;
        font-family: $titlefont;
        font-size: 35px;
        font-weight: bold;
        text-transform: uppercase;
      }

      .texte_aide {
        color: #4c4a49;
        font-family: $textfont;
        font-size: 20px;
      }
    }
  }
}
</style>
